import { render } from "./TmfDocApproval.vue?vue&type=template&id=1e482da6&scoped=true"
import script from "./TmfDocApproval.js?vue&type=script&lang=js"
export * from "./TmfDocApproval.js?vue&type=script&lang=js"

import "./TmfDocApproval.vue?vue&type=style&index=0&id=1e482da6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e482da6"]])

export default __exports__